import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { Tabs, TabsList, TabsTrigger } from "../components/ui/tabs";
import { Plus, Building2, User, Trash2, Pencil } from "lucide-react";
import { toast } from "sonner";
import ClientEditDialog from "../components/ClientEditDialog";

export default function Clients() {
  const [clients, setClients] = useState([]);
  const [tab, setTab] = useState("all");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editing, setEditing] = useState(null);

  const load = async () => {
    const r = await api.get("/clients");
    setClients(r.data);
  };
  useEffect(() => { load(); }, []);

  const openNew = () => { setEditing(null); setDialogOpen(true); };
  const openEdit = (c) => { setEditing(c); setDialogOpen(true); };

  const del = async (id) => {
    if (!window.confirm("Eliminare il cliente e tutti i suoi progetti?")) return;
    await api.delete(`/clients/${id}`);
    toast.success("Eliminato");
    load();
  };

  const filtered = clients.filter((c) => tab === "all" || c.type === tab);

  return (
    <div className="p-8 lg:p-10 space-y-6 fade-up">
      <header className="flex items-start justify-between">
        <div>
          <div className="mono-label">Anagrafica</div>
          <h1 className="font-display text-4xl font-medium mt-1">Clienti</h1>
        </div>
        <Button onClick={openNew} data-testid="new-client-btn" className="brand-bg hover:opacity-90"><Plus className="h-4 w-4 mr-1.5" /> Nuovo cliente</Button>
      </header>

      <ClientEditDialog open={dialogOpen} onOpenChange={setDialogOpen} client={editing} onSaved={load} />

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList>
          <TabsTrigger value="all" data-testid="tab-all">Tutti ({clients.length})</TabsTrigger>
          <TabsTrigger value="private" data-testid="tab-private">Privati ({clients.filter(c=>c.type==="private").length})</TabsTrigger>
          <TabsTrigger value="pa" data-testid="tab-pa">Pubblica Amm. ({clients.filter(c=>c.type==="pa").length})</TabsTrigger>
        </TabsList>
      </Tabs>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {filtered.map((c) => (
          <div key={c.id} className="p-5 border border-neutral-200 bg-white hover:border-neutral-400 hover-lift" data-testid={`client-card-${c.id}`}>
            <div className="flex items-center justify-between mb-3">
              <div className="mono-label flex items-center gap-1.5">
                {c.type === "pa" ? <Building2 className="h-3 w-3" /> : <User className="h-3 w-3" />}
                {c.type === "pa" ? "Pubblica Amm." : "Privato"}
              </div>
              <div className="flex gap-1">
                <button onClick={() => openEdit(c)} data-testid={`edit-client-${c.id}`} className="text-neutral-400 hover:brand-text p-1"><Pencil className="h-4 w-4" /></button>
                <button onClick={() => del(c.id)} className="text-neutral-400 hover:text-red-600 p-1"><Trash2 className="h-4 w-4" /></button>
              </div>
            </div>
            <Link to={`/clients/${c.id}`}>
              <div className="font-display text-lg font-medium leading-tight text-neutral-900">{c.name}</div>
              <div className="text-xs text-neutral-500 mt-1">{c.city || c.email || c.vat || "—"}</div>
              {c.rup && <div className="mono-label mt-2">RUP · {c.rup}</div>}
            </Link>
          </div>
        ))}
        {filtered.length === 0 && (
          <div className="col-span-full py-16 text-center text-sm text-neutral-500 border border-dashed border-neutral-300">
            Nessun cliente. Creane uno per iniziare.
          </div>
        )}
      </div>
    </div>
  );
}
